import { AppSettingContext } from "@src/components/Application";
import React, { useEffect, useRef, useState } from "react";
import IScheduleSendDetails from "../../../models/interfaces/ScheduleSendDetails.interface";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//https://reactdatepicker.com/#example-calendar-icon
//https://www.npmjs.com/package/react-datepicker

interface IRecipientsStepWhenToSendProps {
    model: IScheduleSendDetails;
    sendItLater: boolean;
    handleChangeSendItLater(sendItLater: boolean): void;
    handleModelUpdate(sender: IScheduleSendDetails): void;
}

const RecipientsStepWhenToSend = (props: IRecipientsStepWhenToSendProps) => {
    const ref = useRef(true);

    //Page translation
    const { labels } = React.useContext(AppSettingContext);

    const [date, setDate] = useState(props.model.date);
    const [hour, setHour] = useState(props.model.hour == 0 ? 1 : props.model.hour);
    const [minute, setMinute] = useState(props.model.minute);

    const [formattedDate, setFormattedDate] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {

        //const date: Date = new Date();
        //date.setDate(date.getDate() + 1); //add 1 day
        //setFormattedDate(formatDate(date, 'dd/mm/yyyy'));

        //setDate(date);

        //setTimeout(() => {
        //    initDatePicker();
        //}, 3000);

        //setTimeout(() => {
        //    props.handleModelUpdate({
        //        date: date,
        //        hour: hour,
        //        minute: minute
        //    } as IScheduleSendDetails);
        //}, 2000);

        }, []);

    useEffect(() => {
        propagateChanges();
        //const firstRender = ref.current;
        //if (firstRender == false) {
        //    propagateChanges();
        //}
    }, [date, hour, minute]);

    const propagateChanges = () => {
        //only on change

        props.handleModelUpdate({
            date: date,
            hour: hour,
            minute: minute
        } as IScheduleSendDetails);
    };

    const handleHourChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        //console.debug("handleHourChange", event.target.value);
        setHour(parseInt(event.target.value));
    };

    const handleMinuteChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        //console.debug("handleMinuteChange", event.target.value);
        setMinute(parseInt(event.target.value));
    };

    //const handleSendNow = (event: React.MouseEvent<HTMLButtonElement>) => {
    //    props.handleChangeSendItLater(false);
    //};

    //const handleSendLater = (event: React.MouseEvent<HTMLButtonElement>) => {
    //    props.handleChangeSendItLater(true);
    //};

    //const initDatePicker = () => {
    //    //if (document.querySelector('.send-it')) {

    //    //    const firstRender = ref.current;
    //    //    if (firstRender) {
    //    //        ref.current = false;
    //    //        //console.debug('init .swiper-upload');
    //    //        setIsLoading(false);

    //    //        setTimeout(() => {
    //    //            if (document.querySelector('input[name="send-it__date"]')) {

    //    //                const elem = document.querySelector('input[name="send-it__date"]');
    //    //                const minDate = document.querySelector('input[name="send-it__date"]').getAttribute('data-mindate')
    //    //                const datepicker = new Datepicker(elem, {
    //    //                    format: 'dd MM yyyy',
    //    //                    minDate: minDate,
    //    //                    prevArrow: '<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 11L1 6L6 1" stroke="#111827" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    //    //                    nextArrow: '<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L1 11" stroke="#111827" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    //    //                });


    //    //            }
    //    //        }, 100);

    //    //    }
    //    //}
    //};

    const addDays = (date: Date, days: number) => {
        if (date) {
            date.setDate(date.getDate() + days);
        }
        return date;
    }

    const subDays = (date: Date, days: number) => {
        if (date) {
            date.setDate(date.getDate() - days);
        }
        return date;
    }

    const isDateSame = (date: Date) => {
        const today = new Date();
        if (date) {
            return date.getDate() == today.getDate()
                && date.getMonth() == today.getMonth()
                && date.getFullYear() == today.getFullYear();
        }

        return false;
    }

    if (error) throw error;
    return (
        <div className="send-it">

            {/*<input type="checkbox"
                defaultChecked={false}
                onChange={handleChangeSendItLater}
                name="send-it__later" id="send-it__later" data-recipients /> */}

            <hr />
            <h5>{labels.get("GiftCard.App.Steps.Recepients.Fields.WhenToSend.Title")}</h5>
            <div className="btns">
                <button onClick={(e) => props.handleChangeSendItLater(false)}
                    className={`btn btn__medium medium-fs ${props.sendItLater ? "btn__outlined" : "btn__primary"}`}>{labels.get("GiftCard.App.Steps.Recepients.Fields.WhenToSend.Btn.SendNow")}</button>
                <button onClick={(e) => props.handleChangeSendItLater(true)}
                    className={`btn btn__medium medium-fs ${props.sendItLater ? "btn__primary" : "btn__outlined"}`}>{labels.get("GiftCard.App.Steps.Recepients.Fields.WhenToSend.Btn.SendLater")}</button>

                {/*<label className="btn btn__primary btn__medium medium-fs" htmlFor="send-it__later">{labels.get("GiftCard.App.Steps.Recepients.Fields.WhenToSend.Btn.SendLater")}</label>*/}
            </div>

            <div className={`flex-container date ${props.sendItLater ? "" : "date-hide fadeIn"}`}>
                <div className="form-field">
                    <label htmlFor="send-it__date">Date</label>
                    <div className="date-picker">
                        <DatePicker
                            id="send-it__date" name="send-it__date"
                            showIcon
                            dateFormat="dd MMMM yyyy"
                            calendarClassName=""
                            className="send-it__date-picker"
                            placeholderText=''
                            minDate={new Date()}
                            maxDate={addDays(new Date(), 120)}
                            closeOnScroll={(e) => e.target === document}
                            selected={date}
                            onChange={(d) => setDate(d)}
                            calendarStartDay={1}
                        />

                        <img src="/static/icons/date-icon.svg" alt="Date" />
                        <img src="/static/icons/input-select-icon.svg" alt="Select" />
                    </div>
                </div>


                {/*<div className="form-field">*/}
                {/*    <label htmlFor="send-it__date">Date</label>*/}
                {/*    <div className="date-picker">*/}
                {/*        <input type="text" name="send-it__date" id="send-it__date"*/}
                {/*            ref={dateEditRef}*/}
                {/*            onChange={handleDateChange}*/}
                {/*            data-date={formattedDate}*/}
                {/*            data-mindate={formattedDate} readOnly={true} />*/}

                {/*        <img src="/static/icons/date-icon.svg" alt="" />*/}
                {/*        <img src="/static/icons/input-select-icon.svg" alt="" />*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="form-field">
                    <label htmlFor="send-it__hour">Hour</label>
                    <div className="select-field">
                        <select name="send-it__hour" id="send-it__hour"
                            onChange={handleHourChange} value={hour}>
                            {
                                (
                                    () => {
                                        const options = [];
                                        for (let i = 0; i <= 23; i++) {
                                            if (isDateSame(date) && (i < date.getHours())) {
                                                continue;
                                            }

                                            options.push(<option key={i} value={i}>{i.toString().padStart(2, '0')}</option>);
                                        }
                                        return options
                                    }
                                )()
                            }
                        </select>
                        <img src="/static/icons/input-select-icon.svg" alt="Select" />
                    </div>
                </div>
                <div className="form-field">
                    <label htmlFor="send-it_minute">Minute</label>
                    <div className="select-field">
                        <select name="send-it__minute" id="send-it__minute"
                            onChange={handleMinuteChange} value={minute}>
                            {
                                (
                                    () => {
                                        const options = [];
                                        for (let i = 0; i <= 59; i++) {
                                            options.push(<option key={i} value={i}>{i.toString().padStart(2, '0')}</option>);
                                        }
                                        return options
                                    }
                                )()
                            }
                        </select>
                        <img src="/static/icons/input-select-icon.svg" alt="Select" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RecipientsStepWhenToSend;